"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TIMED_OUT_DELAY = exports.DEFAULT_POLL_INTERVAL = void 0;
exports.isReady = isReady;
/** Default interval between polling checks of isAnalyticsProviderReady flag (in ms). */
const DEFAULT_POLL_INTERVAL = exports.DEFAULT_POLL_INTERVAL = 200;

/**
 * Default total amount of time to continue polling for isAnalyticsProviderReady flag (in ms).
 * If this runs out, the isReady promise will get rejected.
 */
const DEFAULT_TIMED_OUT_DELAY = exports.DEFAULT_TIMED_OUT_DELAY = 10000;
let readyPromise;
async function isReady(pollInterval = DEFAULT_POLL_INTERVAL, timedOutDelay = DEFAULT_TIMED_OUT_DELAY) {
  let pollTimeoutId;
  let totalDelayTimeout;
  if (readyPromise === undefined) {
    readyPromise = new Promise((resolve, reject) => {
      const poll = () => {
        if (window.isAnalyticsProviderReady === undefined) {
          pollTimeoutId = setTimeout(() => poll(), pollInterval);
        } else {
          clearTimeout(totalDelayTimeout);
          resolve(true);
        }
      };
      totalDelayTimeout = setTimeout(() => {
        clearTimeout(pollTimeoutId);
        reject(new Error('Analytics provider is not ready.'));
      }, timedOutDelay);
      poll();
    });
  }
  return readyPromise;
}